import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';
import { useLenis } from './hooks/useLenis';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import EditorialMarquee from './components/EditorialMarquee';
import Prestations from './components/Prestations';
import MobileBar from './components/MobileBar';
import Cocktails from './components/Cocktails';
import WhyUs from './components/WhyUs';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import Prospection from './pages/Prospection';

function SiteHome() {
  useLenis();
  return (
    <div className="App grain relative bg-cream text-char overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <About />
        <EditorialMarquee />
        <Prestations />
        <MobileBar />
        <Cocktails />
        <WhyUs />
        <Reviews />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SiteHome />} />
        <Route path="/gestion" element={<Prospection />} />
      </Routes>
      <Toaster
        theme="light"
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#FFFDF6',
            color: '#221D15',
            border: '1px solid rgba(184,145,44,0.35)',
            borderRadius: 0,
            fontFamily: 'Outfit, sans-serif',
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
